<template>
  <search-group-form-page
      v-if="tagSearch"
      :key="`edit-tag-${tagSearch_id}-${tagSearch.updated_at}`"
      :url="`projects/${project_id}/searches/tag_library/${tagSearch_id}`"
      :resource-name="resourceName"
      :item_id="tagSearch_id"
      :item="tagSearch"
      :title="$t('booleanSearch.edit_bool_tagSearch')"
      :detail-fields="detailFields"
      :hide-filters="true"
      :is-busy="isBusy"
  />
</template>

<script>
// Plugins
import { mapActions, mapState } from "vuex";

// Components
import SearchGroupFormPage from "../../components/boolean-search/SearchGroupFormPage.vue";
// Mixins
import notifyMessages from "../../mixins/boolean-search/notifyMessages";

export default {
  name: "edit-tag-search",

  props: {
    tagSearch_id: { // prop from $router
      type: String,
      required: true
    }
  },

  mixins: [ notifyMessages ],

  async created() {
    const id = parseInt(this.tagSearch_id)
    this.$store.commit('booleanSearch/RESET_SINGLE_RESOURCE', this.resourceName)
    await this.getQuery({url: `projects/${this.project_id}/searches/tag_library/${id}`, key: this.resourceName}).catch(() => this.notifyStoreError())
  },

  data() {
    return {
      resourceName: 'tagSearch',
    }
  },

  computed: {
    ...mapState({
      project_id: state => state.booleanSearch.project_id,
      tagSearch: state => state.booleanSearch.tagSearch,
      tag_library: state => state.booleanSearch.tag_library,
    }),
    isBusy() { return this.tagSearch.isBusy },
    detailFields() { 
      return ['name', 'multiSyntax','boolTagCategory'].concat(this.tag_library.showPrivateTags ? ['isPrivateTag'] : []) 
    },
  },

  methods: {
    ...mapActions({
      getQuery: 'booleanSearch/getSingleResource',
    }),
  },

  components: {
    SearchGroupFormPage
  }
}
</script>